import {radioAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/unbound-method
const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(radioAnatomy.keys)

const baseStyle = definePartsStyle({
    control: {
        width: 'iconsSize.medium',
        height: 'iconsSize.medium',
        flexShrink: 0,
        borderColor: 'border.dark',
        _checked: {
            bg: 'background.default !important',
            borderColor: 'border.dark !important',
            color: 'text.primary',
            boxShadow: 'none',
        },
        '.chakra-radio__control': {
            boxShadow: 'none',
        },
        '&[data-focus-visible]': {
            boxShadow: 'none',
        },
    },
})

export default defineMultiStyleConfig({baseStyle})
